import ProductsRelatedPresenter from "../components/products-related/presenter/products-related.js";

const productsListWrapper = document.querySelector(`.products-list-related-wrapper`);
const categoryLinksList = document.querySelector(`.category-links_related-products`);

if (productsListWrapper) {
  const productsRelatedComponent = new ProductsRelatedPresenter(
      productsListWrapper,
      categoryLinksList
  );
  productsRelatedComponent.init();
}

